<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">account_circle</mat-icon>
    Re-Assign
  </div>
  <button type="button" aria-label="Close" (click)="onCancelClick()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<form style="padding: 20px;">
  <label style="font-weight: 500;font-size: 14px;">Re-Assign To</label>
  <mat-form-field class="reassign-field">
    <input type="text" placeholder="Search User" aria-label="Re-Assign To" matInput [formControl]="myControl"
      [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="assignReleaseWorkItem($event.option.value)">
      @for (gpid of filteredOptions | async; track gpid) {
      <mat-option [value]="gpid?.value">{{gpid?.name}}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>